import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { InstanceEntity } from 'mj_generatedentities';
import { MetadataLoadingStage, UserContextService } from 'src/app/core/services/user-context.service';
import { buildRoutePrefix } from 'src/app/core/util';
import { InstanceProviderService } from '../instance-provider.service';
import { MJEventType, MJGlobal } from '@memberjunction/global';


/**
 * This component will display a simple list of instances that the user can select from. The user will be able to select an instance from the list and the application will navigate to the selected instance.
 */
@Component({
  selector: 'app-instance-dropdown',
  template: `
  @if (Instances.length >= MinInstancesToShowComponent) {
    <kendo-dropdownlist
        #sizes
        [data]="Instances"
        textField="Name"
        valueField="ID"
        [(ngModel)]="CurrentInstance"
        (selectionChange)="navigateToInstance($event)"
      >
      </kendo-dropdownlist>
    <!-- <select ()>
      <option *ngFor="let instance of Instances" (click)="navigateToInstance(instance.ID)">{{instance.Name}}</option>
    </select> -->
  }
  `,
  styles: []
})
export class InstanceDropdownComponent {

  /**
   * This property will determine the minimum number of instances that need to be present in order to show the component. If the number of instances is less than this value, the component will not be shown. The default value is 2. The idea here is to not show 
   * an unnecessary dropdown if there is only one instance.
   */
  @Input() MinInstancesToShowComponent = 2;

  constructor(private router: Router, private orgService: UserContextService, private instanceProvider: InstanceProviderService) {
    this.orgService.MetadataLoadingStage$.subscribe((loaded) => {
      if (loaded >= MetadataLoadingStage.InstanceMetadataLoaded) {
        this.Instances = this.orgService.Instances;
        this.CurrentInstance = this.orgService.CurrentInstance;
      }
    });
  }


  public CurrentInstance: InstanceEntity;
  public Instances: InstanceEntity[] = [];

  // This method will navigate to the selected instance.
  async navigateToInstance(newItem: InstanceEntity) {
    const instanceId = newItem.ID;
    this.CurrentInstance = this.orgService.Instances.find(i => i.ID === instanceId);
    await this.orgService.SetCurrentInstance(instanceId);
    await this.instanceProvider.TriggerInstanceProviderSetup(instanceId);
    const prefix = buildRoutePrefix(instanceId);
    this.router.navigate([prefix, 'chat']);
  }

}